"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Negativni = void 0;
var icons_1 = require("@ant-design/icons");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var utils_1 = require("../../../../utils/utils");
// eslint-disable-next-line import/no-cycle
var ZahranicniAdresaField_1 = require("../../../Form/fields/AddressField/ZahranicniAdresaField");
var BulbIcon_1 = __importDefault(require("../../../Icon/BulbIcon"));
var Table_1 = require("../../../Table");
var Tooltip_1 = __importDefault(require("../../../Tooltip/Tooltip"));
var utils_2 = require("./utils");
var LinkStyle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #005285;\n  cursor: pointer;\n"], ["\n  color: #005285;\n  cursor: pointer;\n"])));
var EditDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .click {\n    cursor: pointer;\n  }\n  display: flex;\n  column-gap: 10px;\n  padding-left: 2px;\n"], ["\n  .click {\n    cursor: pointer;\n  }\n  display: flex;\n  column-gap: 10px;\n  padding-left: 2px;\n"])));
var StyledCloseButton = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #2362a2;\n  margin-left: 5px;\n  display: flex;\n  align-self: baseline;\n  font-size: 16px;\n"], ["\n  color: #2362a2;\n  margin-left: 5px;\n  display: flex;\n  align-self: baseline;\n  font-size: 16px;\n"])));
exports.Negativni = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: #f7f9fa;\n  padding: 9px 16px;\n  ", "\n"], ["\n  background-color: #f7f9fa;\n  padding: 9px 16px;\n  ",
    "\n"])), function (_a) {
    var isDetail = _a.isDetail;
    return isDetail && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin: 1rem 3rem 3rem 3rem;\n    "], ["\n      margin: 1rem 3rem 3rem 3rem;\n    "])));
});
var StyledInfoDiv = styled_components_1.default(ZahranicniAdresaField_1.InfoDiv)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 10px 36px 10px 20px;\n  margin: ", ";\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #3b3b3b;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 10px 36px 10px 20px;\n  margin: ", ";\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #3b3b3b;\n"])), function (_a) {
    var isDetail = _a.isDetail;
    return isDetail && '1rem 3rem 3rem 3rem';
});
var PomuckyTable = function (_a) {
    var data = _a.data, isDetail = _a.isDetail, onRemove = _a.onRemove, onEdit = _a.onEdit;
    return !data || !data.length ? (react_1.default.createElement(StyledInfoDiv, { isDetail: isDetail },
        react_1.default.createElement(BulbIcon_1.default, null),
        "Evidovan\u00E9 osob\u011B nebyla vyd\u00E1na \u017E\u00E1dn\u00E1 pom\u016Fcka.")) : (react_1.default.createElement(utils_2.StyledTable, { isDetail: isDetail },
        react_1.default.createElement(Table_1.Table, { size: "default", keyColumn: "id", data: data, columns: [
                {
                    title: 'Identifikace',
                    dataIndex: 'identifikace',
                    render: function (_, item) { return (react_1.default.createElement("span", null,
                        react_1.default.createElement("b", null, item.idPomucky))); },
                },
                {
                    title: 'Pomůcka',
                    dataIndex: 'typPomucka',
                    render: function (_, item) { return (react_1.default.createElement("span", null,
                        react_1.default.createElement("b", null, item.typPomucky.nazev))); },
                },
                {
                    title: 'Vydáno',
                    dataIndex: 'vydano',
                    render: function (_, item) { return react_1.default.createElement("span", null, utils_1.formatDate(item.datumVydani)); },
                },
                {
                    title: 'Vráceno',
                    dataIndex: 'vraceno',
                    render: function (_, item) { return react_1.default.createElement("span", null, utils_1.formatDate(item.datumVraceni)); },
                },
                isDetail
                    ? {
                        title: 'Poznámka',
                        dataIndex: 'poznamka',
                        render: function (_, item) { return (react_1.default.createElement("span", null, item.poznamka && (react_1.default.createElement(Tooltip_1.default, { content: item.poznamka, on: "click" },
                            react_1.default.createElement(LinkStyle, null, "Zobrazit"))))); },
                    }
                    : {
                        title: 'Upravit',
                        dataIndex: 'edit',
                        render: function (_, item) { return (react_1.default.createElement(EditDiv, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "click", icon: free_solid_svg_icons_1.faPen, color: "#2362a2", size: "1x", onClick: function () { return onEdit && onEdit(item); } }),
                            react_1.default.createElement(StyledCloseButton, { className: "click", onClick: function () { return onRemove && onRemove(item); } }))); },
                    },
            ] })));
};
PomuckyTable.defaultProps = {
    onRemove: undefined,
    onEdit: undefined,
};
exports.default = PomuckyTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
